import core from "@subly/s1/core";


const ensureImage = async (image: File | string | null) => {
	if (!image) return null;
	else if (core.is.file(image)) return await core.toBase64(image) as string;
	else return image;
};

export default {
	...core,
	is: {
		...core.is,
		number: (value: unknown) => typeof value === "number"
	},
	ensureImage
};